/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'
import { Row, Form, Select } from 'antd'
import { useTranslation } from 'next-i18next'
import { ProjectKindType } from 'src/core/models'
import { ProjectFormButtonContinue } from '../index'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomSelect, FormLabels, CustomCol } from 'src/components'
import {
  isForwardProducerSelector,
  projectFormKindSelector,
  setProjectFormItemValue,
  restFormKindChanged,
} from 'src/features'

const ProjectFormDefinition: React.FC = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const currentProjectKind = useAppSelector(projectFormKindSelector)
  const isCarbonForwardVisible = useAppSelector(isForwardProducerSelector)
  const isEdit = useRouter().route?.includes('/my-projects/edit')

  const onFinish = ({ kind }: { kind : ProjectKindType }) => {
    dispatch(setProjectFormItemValue({ key: 'kind', value: kind }))
    dispatch(setProjectFormItemValue({ key: 'activeStep', value: 'LOCATION' }))
  }

  useEffect(() => {
    form.setFieldsValue({ ['kind']: currentProjectKind })
  }, [form, currentProjectKind])

  useEffect(() => {
    if (!isEdit) {
      dispatch(restFormKindChanged())
      if (currentProjectKind === 'carbon_forward') {
        dispatch(setProjectFormItemValue({ key: 'is_vintage', value: true }))
      }
    }
  }, [currentProjectKind])

  const options = [
    { key: 'compensation', label: t('admin.Brokerage.Compensation') },
    { key: 'energy', label: t('admin.Brokerage.Energy') },
    { key: 'contribution', label: t('admin.Brokerage.NBS') },
    { key: 'biodiversity', label: t('admin.Brokerage.Biodiversity') },
    ...(isCarbonForwardVisible ? [{ key: 'carbon_forward', label: t('Forward.Title') }] : []),
  ]

  return <Form onFinish={onFinish} form={form}>
    <Row>
      <CustomCol>
        <FormLabels
          title={t('Projects.Form.Kind')}
          subtitle={t('Projects.Form.KindLabel')}
        />
      </CustomCol>

      <CustomCol>
        <CustomSelect
          name='kind'
          required
          disabled={isEdit}
          showSearch={false}
          placeholder={t('admin.Brokerage.SelectPlaceHolder')}
          onChange={(value: ProjectKindType) => dispatch(setProjectFormItemValue({ key: 'kind', value }))}
        >
          {options.map((option) => <Select.Option key={option.key}>{option.label}</Select.Option>)}
        </CustomSelect>
      </CustomCol>
    </Row>

    <ProjectFormButtonContinue />
  </Form>
}

export default ProjectFormDefinition
